import { createTheme } from '@mui/material/styles';
import { buttonVariants } from './buttonVariants';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#005972',
      dark: '#004B61',
      contrastText: '#ffffff',
    },
    error: {
      main: '#E1000C',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['DB Heavent', 'Arial', 'Helvetica Neue', 'sans-serif'].join(','),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          letterSpacing: 0,
          textTransform: 'none',
        },
        sizeSmall: {
          fontSize: '1rem',
          minHeight: 34,
          padding: '0.25rem 1.25rem',
        },
        sizeMedium: {
          fontSize: '1.25rem',
          minHeight: 40,
          padding: '0.5rem 2rem',
        },
        sizeLarge: {
          fontSize: '1.5rem',
          minHeight: 48,
          padding: '0.75rem 2.5rem',
        },
      },
      variants: buttonVariants,
    },
  },
});
